import EmptyResult from 'components/others/EmptyResult';
import ClientTableRow from './ClientTableRow';
import type { NewSaleType } from 'modules/objects';
import type { NewObjectType } from 'modules/lead';

interface ClientsTableBodyProps {
    clientsList: any[];
    fetchClients: (force?: boolean) => Promise<void>;
    setEditClientId: (clientId: number) => void;
    setInfoClientId: (clientId: number) => void;
    setSubjectsClientId: (clientId: number) => void;
    onCreateSale?: (sale: NewSaleType) => void;
    onCreateObject?: (object: NewObjectType) => void;
}

const ClientsTableBody = ({
    clientsList,
    fetchClients,
    setEditClientId,
    setInfoClientId,
    setSubjectsClientId,
    onCreateSale,
    onCreateObject,
}: ClientsTableBodyProps) => {
    return (
        <tbody>
            {clientsList?.map((client) => (
                <ClientTableRow
                    key={client.ID}
                    client={client}
                    fetchClients={fetchClients}
                    setEditClientId={setEditClientId}
                    setInfoClientId={setInfoClientId}
                    setSubjectsClientId={setSubjectsClientId}
                    onCreateSale={onCreateSale}
                    onCreateObject={onCreateObject}
                />
            ))}

            {clientsList.length === 0 && (
                <tr>
                    <td colSpan={6}>
                        <EmptyResult />
                    </td>
                </tr>
            )}
        </tbody>
    );
};

export default ClientsTableBody;
